import axios from "axios";

export default class BaseService {
  constructor(serviceName) {
    this.http = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        "Content-type": "application/json",
        'Access-Control-Max-Age': 600,
        'Cache-Control': 'max-age=600'
      }
    });

    this._setAuthorizationInterceptor();

    this._serviceName = serviceName;
  }

  _setAuthorizationInterceptor() {
    this.http.interceptors.request.use((config) => {
      let accessToken = localStorage.getItem('access_token');
      if (accessToken) config.headers.common['Authorization'] = `Bearer ${accessToken}`;
      // if (accessToken) config.headers.common['Odoo-Token'] = `${accessToken}`;
      return config;
    });
  }
}
